<template>
  <div>
    <div class="tab_wrapper">
    <div class="tab">
        <router-link to="/home/discuss" class="tab_cell">
          券友评论
        </router-link>
        <router-link to="/news/getCoins" class="tab_cell">
          收到券币<span class="new_num">8</span>
        </router-link>
        <router-link to="/news/systemNotify" class="tab_cell">
          系统通知
        </router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"news",
    created () {
      this.$router.push('/news/getCoins')
    }
  }
</script>
<style lang="stylus">
  .tab_wrapper
    padding:25px 40px
    background:#fff
    border-bottom:1px solid #e6e6e6
    box-sizing:border-box
    /*px*/
    .tab
      width:100%
      display:flex
      box-sizing:border-box
      height:64px
      width:100%
      box-sizing:border-box
      border:2px solid #ff4c25
      line-height:60px
      border-radius:32px
      .tab_cell
        flex:1
        height:60px
        font-size:28px
        color:#292929
        text-align:center
        border-radius:30px
        &.router-link-active
          color:#fff
          background:#ff4c25
          .new_num
            display:none
        .new_num
          display:inline-block
          width:32px
          height:32px
          border-radius:16px
          font-size:22px
          color:#fff
          background:#ff4c25
          line-height:32px
          vertical-align:top
          margin-top:12px
          margin-left:5px

</style>



// WEBPACK FOOTER //
// src/components/userCenter/news/news.vue